export default function Recipe({ content }) {
  const {
    title,
    description,
    datePublished,
    dateModified,
    path,
    SEOImage,
    headline,
    keywords,
  } = content
  const keywordsJoined = `"${keywords.join('","')}"`
  const images = `"${SEOImage.join('","')}"`
  const data = `{
    "@context":"http://schema.org/",
    "@type":"Article",
    "name":"${title}",
    "author": {
      "@type":"Person",
      "name":"Giselle Santín",
      "url":"http://www.vivelowcarb.com/aboutme"
    },
    "image":[
      ${images}
    ],
    "mainEntityOfPage":"http://www.vivelowcarb.com${path}",
    "description": "${description}",
    "headline": "${headline}",
    "datePublished": "${datePublished}",
    "dateModified": "${dateModified}",
    "keywords":[${keywordsJoined}],
    "publisher": {
      "name": "Vive Low Carb",
      "logo": {
        "height": 155,
        "url": "https://vivelocarb.s3-eu-west-1.amazonaws.com/vivelowcarblogo.webp",
        "width": 300
      }
    }
  }`
  return data
}
